<mat-form-field
	(click)="openFilterDropdown()"
	class="multi-layer-filter-container"
	[ngClass]="{ dropped: filterOpen }"
	appearance="fill"
>
	<!-- Label -->
	<mat-label class="filter-label" [ngClass]="{ hide: hidePlacehoder }"> {{ label() }} </mat-label>

	<ng-container [formGroup]="optionSearchForm">
		<div class="selected-options-container" #optionContainer></div>

		<!-- Input type ahead -->
		<input
			matInput
			class="hidden-input"
			type="text"
			autocomplete="on"
			[formControl]="control"
			[matAutocomplete]="auto"
			(input)="handleEmptyInput($event)"
		/>
		<!-- Clear icon -->
		<div class="clear-icon-container" *ngIf="hidePlacehoder">
			<app-icon
				[name]="'close-circle-bold'"
				[fill]="'rgba(0, 0, 0, 0.54)'"
				[color]="'transaprent'"
				(click)="clearSelected($event)"
			></app-icon>
		</div>

		<!-- Arrow down icon -->
		<app-icon
			class="option-dropdown-arrow"
			[color]="'rgba(0, 0, 0, 0.54)'"
			[lineWidth]="'2.5'"
			[name]="'arrow-down'"
			[size]="'16'"
			[ngClass]="{ 'up-arrow': filterOpen }"
		></app-icon>

		<mat-autocomplete
			#auto="matAutocomplete"
			class="auto-complete-container"
			[displayWith]="inputAutocompleteService.displayMultipleFn"
			(opened)="onTouched($event)"
			(closed)="closeFilterDropdown(true)"
		>
			<div class="option-search-container flex flex-align-center">
				<app-icon matPrefix [name]="'search-normal-1'" [size]="'15'" class="search-icon"></app-icon>
				<input
					matInput
					[placeholder]="'Search by status or bulk action'"
					formControlName="search"
					class="input"
					#searchInput
					(keydown.enter)="openFilterDropdown()"
				/>
			</div>

			<div *ngIf="filterOpen" #scrollContainer class="scrollable-container" (scroll)="onScroll()">
				<!-- Options -->
				<ng-container *ngFor="let transaction of filteredTransactionOptions; let i = index">
					<div [class.transaction-container]="transaction.type !== 'noOptions'">
						<span *ngIf="transaction.type !== 'noOptions'" class="option-header">{{
							transaction.name
						}}</span>
						<mat-option
							*ngFor="let option of transaction.options"
							class="custom-option"
							[value]="option"
							[ngClass]="{ disabled: option.disable }"
						>
							<div
								class="option-container"
								#optionElement
								(click)="optionChecked($event, option)"
								[ngClass]="{ disabled: option.disable }"
							>
								<mat-checkbox
									class="checkbox"
									[disabled]="option.disable"
									[checked]="option.selected === true"
									(change)="optionElement.click()"
									(click)="optionElement.click()"
									*ngIf="option.value !== 'noOptions'"
								></mat-checkbox>
								{{ option.text }}
							</div>
						</mat-option>
						<mat-divider *ngIf="i === 0"></mat-divider>
					</div>
				</ng-container>
			</div>
		</mat-autocomplete>
	</ng-container>
</mat-form-field>
